<template>
  <div>
    <form class="filter__form" @submit="submit">
      <div class="row center"><strong>Поиск</strong></div>
      <div class="row">
        <div class="col-md-6">
          По номеру заказа<br>
          <text-input name="ORDER_ID" label='ID заказа' v-model="ORDER_ID"></text-input>
        </div>
        <div class="col-md-6">
          По артикулу товара в заказе<br>
          <text-input name="ARTICLE_ID" label='Артикул' v-model="ARTICLE_ID"></text-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          По дате<br>
          <div class="form-group">
            <input type="date" name="ORDER_DATA_START" class="form-control" v-model="ORDER_DATE_START">
            <span> - </span>
            <input type="date" name="ORDER_DATA_END" class="form-control" v-model="ORDER_DATE_END">
          </div>
        </div>
        <div class="col-md-6">
          По стоимости<br>
          <div class="form-group">
            <input type="number" name="ORDER_PRICE_START" class="form-control" v-model="ORDER_PRICE_START">
            <span> - </span>
            <input type="number" name="ORDER_PRICE_END" class="form-control" v-model="ORDER_PRICE_END">
          </div>
        </div>
      </div>
      <div class="row">
        <btn :loading="false" title="Найти"></btn>
        <div class="btn btn-secondary" @click="formClear"><span>Сбросить</span></div>
      </div>
    </form>
    <div class="table__wrapper">
      <table>
        <thead>
        <tr>
          <th>Код заказа</th>
          <th>Дата</th>
          <th>Товар</th>
          <th>Статус</th>
          <th>Оплата</th>
          <th>Трек номер</th>
          <th>Доствка</th>
          <th>Стоимость</th>
          <th>Действия</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order of orders">
          <td><b>{{order.ID}}</b><br/></td>
          <td>{{order.DATE_INSERT}}</td>
          <td>
              <a class="link_product"
                 v-for="product of order.ITEMS"
                 :href="product.DETAIL_PAGE_URL"
              >{{product.NAME}}</a>
          </td>
          <td>
            {{order.STATUS}}
          <td>
            <span v-for="paySystem of order.PAY_SYSTEMS">{{paySystem.NAME}}</span>
          </td>
          <td>{{order.TRACK}}</td>
          <td>
            <span v-for="delivery of order.DELIVERIES">{{delivery.NAME}} </span>
          </td>
          <td>{{order.PRICE}} Р</td>

          <td>
            <a class="link_green" title="Подробно"
               :href="'/personal/order/order_detail.php?ID=' + order.ID"
               target="_blank">Подробно</a><br/>
            <a class="link_green" title="Повторить"
               :href="'/personal/order/?ID=' + order.ID + '&COPY_ORDER=Y'">Повторить</a>
            <br/>
            <a class="link_green" title="Отменить" v-if="order.CAN_CANCEL"
               :href="'/personal/order/order_cancel.php?ID=' + order.ID + '&CANCEL=Y'">Отменить</a>
            <a class="link_green" title="Оплатить" v-for="paySystem of order.PAY_SYSTEMS"
               v-if="order.CAN_PAY"
               :href="paySystem.PAY_URL" target="_blank">Оплатить</a><br/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <el-pagination
        layout="prev, pager, next"
        :total="countElements"
        :page-size="limit"
        @current-change="onPageChange"
    >
    </el-pagination>
    <div class="loader__wrapper">
      <loader v-if="loading">
      </loader>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import Loader from '../Loader'
  import TextInput from '../form/TextInput.vue'
  import DateInput from '../form/DateInput.vue'
  import BaseInput from '../BaseInput.vue'
  import Btn from '../form/Btn.vue'

  export default {
    name: 'orders',
    components: {Loader, TextInput, DateInput, BaseInput, Btn},
    data () {
      return {
        formData: '',
        ORDER_ID: '',
        ARTICLE_ID: '',
        ORDER_DATE_START: '',
        ORDER_DATE_END: '',
        ORDER_PRICE_START: '',
        ORDER_PRICE_END: ''
      }
    },
    created () {
      if (this.orders.length <= 0) {
        this.fetchOrders({page: 1, filter: this.formData})
      }
    },
    computed: {
      ...mapGetters('orders', [
        'orders',
        'loading',
        'countElements',
        'limit'
      ])
    },
    methods: {
      ...mapActions('orders', [
        'fetchOrders'
      ]),
      onPageChange (page) {
        this.formData = {
          ORDER_ID: this.ORDER_ID,
          ARTICLE_ID: this.ARTICLE_ID,
          ORDER_DATE_START: this.ORDER_DATE_START,
          ORDER_DATE_END: this.ORDER_DATE_END,
          ORDER_PRICE_START: this.ORDER_PRICE_START,
          ORDER_PRICE_END: this.ORDER_PRICE_END
        }
        this.fetchOrders({page: page, filter: this.formData})
      },
      submit ($event) {
        $event.preventDefault()
        this.formData = {
          ORDER_ID: this.ORDER_ID,
          ARTICLE_ID: this.ARTICLE_ID,
          ORDER_DATE_START: this.ORDER_DATE_START,
          ORDER_DATE_END: this.ORDER_DATE_END,
          ORDER_PRICE_START: this.ORDER_PRICE_START,
          ORDER_PRICE_END: this.ORDER_PRICE_END
        }
        this.fetchOrders({page: 1, filter: this.formData})
      },
      formClear ($event) {
        $event.preventDefault()
        this.ORDER_ID = ''
        this.ARTICLE_ID = ''
        this.ORDER_DATE_START = ''
        this.ORDER_DATE_END = ''
        this.ORDER_PRICE_START = ''
        this.ORDER_PRICE_END = ''
        this.formData = {
          ORDER_ID: this.ORDER_ID,
          ARTICLE_ID: this.ARTICLE_ID,
          ORDER_DATE_START: this.ORDER_DATE_START,
          ORDER_DATE_END: this.ORDER_DATE_END,
          ORDER_PRICE_START: this.ORDER_PRICE_START,
          ORDER_PRICE_END: this.ORDER_PRICE_END
        }
        this.fetchOrders({page: 1, filter: this.formData})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .loader__wrapper {
    height: 50px;
    width: 100%;
    position: relative;
  }
  .link_product {
    display: block;
  }
  table thead tr th {
    padding-left: 10px;
    padding-right: 10px;
  }
  table tbody tr td {
    padding: 25px 0 0 10px;
  }
  .filter__form {
    border: solid 1px #e5f8f0;
    border-radius: 5px;
    padding: 10px;
    overflow: hidden;
  }
  .filter__form .row {
    text-align: center;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Orders.vue